import { Navbar } from "@/components/navbar";
import { Hero } from "@/components/hero";
import { StatsRow } from "@/components/sections/stats-row";
import { CaseStudyGallery } from "@/components/sections/case-study-gallery";
import { ServicesExplorer } from "@/components/sections/services-explorer";
import { WorkshopsSchedule } from "@/components/sections/workshops-schedule";
import { SherpaHome } from "@/components/sections/sherpa-home";
import { AiTakeSection } from "@/components/sections/ai-take-section";
import { TeamSectionV2 } from "@/components/sections/team-section-v2";
import { ValuesAccordion } from "@/components/sections/values-accordion";
import { AwardsSectionV2 } from "@/components/sections/awards-section-v2";
import { ContactCta } from "@/components/sections/contact-cta";
import { AskAiAboutUs } from "@/components/sections/ask-ai-about-us";
import { usePageMeta, organizationSchema, websiteSchema, localBusinessSchema, PAGE_META } from "@/lib/seo";

export default function Home() {
  usePageMeta({
    title: PAGE_META["/"].title,
    description: PAGE_META["/"].description,
    path: "/",
    image: "/images/og/og-home.png",
    jsonLd: [organizationSchema(), websiteSchema(), localBusinessSchema()],
  });

  return (
    <div className="min-h-screen bg-cream font-sans">
      <Navbar />
      <main>
        <Hero />

        <StatsRow
          dark
          animateNumbers
          items={[
            { number: "$1.2B+", label: "Managed Ad Spend" },
            { number: "500+", label: "Clients" },
            { number: "400K+", label: "Students" },
            { number: "14", label: "Years in Business" },
          ]}
        />

        <CaseStudyGallery />

        <ServicesExplorer />

        <WorkshopsSchedule />

        <SherpaHome />

        <AiTakeSection />

        <TeamSectionV2 />

        <AwardsSectionV2 />

        <ValuesAccordion />

        <AskAiAboutUs />

        <ContactCta />
      </main>
    </div>
  );
}
